import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import LazyLoadWrapper from './LazyLoadWrapper';
import Picture from './Picture';

const Image = (props) => {
  const { lazyload } = props;

  return (
    <LazyLoadWrapper lazyload={lazyload}>
      <Picture {...props} />
    </LazyLoadWrapper>
  );
};

Image.propTypes = {
  src: PropTypes.oneOfType([
    PropTypes.string,
    ImmutablePropTypes.map,
  ]).isRequired,
  alt: PropTypes.oneOfType([
    PropTypes.string,
    ImmutablePropTypes.map,
  ]).isRequired,
};
export default Image;
